import { Typography } from "@mui/material";
import { T } from "../../util/t";
import { Check, MarkEmailRead } from "@mui/icons-material";
import { AutoProgressMenuItem } from "../menus/AutoProgressMenuItem";
import { useDispatch } from "react-redux";
import {
    confirmAndCancelPayment,
    confirmAndRequestPayment,
    cancelPayment,
} from "actions/entry";
import { useError } from "hooks/useNotifications";

export const UnpaidMenuItems = ({ entry }) => {
    const { notifyResponseError } = useError();
    const dispatch = useDispatch();

    const onCancelPayment = () =>
        dispatch(cancelPayment(entry.eventDivisionId, entry.id)).catch(
            notifyResponseError,
        );
    const onConfirmAndCancelPayment = () =>
        dispatch(
            confirmAndCancelPayment(entry.eventDivisionId, entry.id),
        ).catch(notifyResponseError);
    const onConfirmAndRequestPayment = () =>
        dispatch(
            confirmAndRequestPayment(entry.eventDivisionId, entry.id),
        ).catch(notifyResponseError);

    if (entry.status === "waitlisted")
        return (
            <>
                <AutoProgressMenuItem
                    onClick={onConfirmAndCancelPayment}
                    startIcon={<Check fontSize="small" />}
                >
                    <Typography>
                        <T>Confirm as paid</T>
                    </Typography>
                </AutoProgressMenuItem>
                <AutoProgressMenuItem
                    onClick={onConfirmAndRequestPayment}
                    startIcon={<MarkEmailRead fontSize="small" />}
                >
                    <Typography>
                        <T>Confirm and request payment</T>
                    </Typography>
                </AutoProgressMenuItem>
            </>
        );

    if (entry.status === "confirmed")
        return (
            <AutoProgressMenuItem
                onClick={onCancelPayment}
                startIcon={<Check fontSize="small" />}
            >
                <Typography>
                    <T>Mark as paid</T>
                </Typography>
            </AutoProgressMenuItem>
        );
};
